import { filter, get } from 'lodash';
import { searchEntities } from '../../store/selectors/search';

// export const selectAssets = state => searchEntities(state, 'assets', ['roomType','customLabel', 'serialNumber', 'item.name', 'item.model', 'item.makeName']);
export const selectAssets = state => searchEntities(state, 'assets', ['name','customLabel']);

export const selectAssetById = (state, id) => selectAssets(state)?.find(u => u.id === id);
export const selectAreaById = (state,areaId) => selectAssets(state)?.find(u => u.areaId === areaId);
export const selectAssetsByAreaId = (state,areaId) => selectAssets(state)?.find(u => u.areaId === areaId).assets;
export const selectAssetByAreaAndAssetId = (state, areaId,assetId) => selectAssetsByAreaId(state,areaId)?.find(u => u.id === assetId)

// export const selectAssetByAreaAndAssetId = (state, areaId,assetId) => selectAssets(state).find(u => u.id === areaId);

export const selectAssetNotes = (state, id) => get(selectAssetById(state, id), ['notes'], []);

export const selectAssetDocuments = (state, id) => get(selectAssetById(state, id), ['documents'], []);
